import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import Reviews from "./pages/Reviews";
import Production from "./pages/Production";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import { useLenis } from "./lib/motion";
import "./App.css";

function App() {
  useLenis();
  return (
    <HelmetProvider>
      <div className="App min-h-screen relative">
        <BrowserRouter>
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/productions/:slug" element={<Production />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
